import reportStockService from "../services/reportStockService";

export const GET_REPORT_STOCKS_REQUEST = "@reason/get-report-stocks-request";
export const GET_REPORT_STOCKS_SUCCESS = "@reason/get-report-stocks-success";
export const GET_REPORT_STOCKS_FAILURE = "@reason/get-report-stocks-failure";

export function getReportStocks(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_REPORT_STOCKS_REQUEST});
      const response = await reportStockService.getReportStocks(params);
      dispatch({
        type: GET_REPORT_STOCKS_SUCCESS,
        payload: {
          response: response.data,
          total: response.total || 0
        }
      });
      return response;
    } catch (error) {
      dispatch({type: GET_REPORT_STOCKS_FAILURE});
      throw error;
    }
  };
}
